import { gql } from '@apollo/client';
import { ProductRenewalIntervalInfo } from '../fragments';

export default gql`
  query productRenewalInterval($id: ID) {
    productRenewalInterval(id: $id) {
      ...ProductRenewalIntervalInfo
    }
  }
  ${ProductRenewalIntervalInfo}
`;
